/**
 * Détermine toutes la liste des dépendances pour un droit
 * @param right
 */
export const getDependencies = (right) => {
  if (!right.dependencies) {
    return []
  }
  const dep = []
  right.dependencies.forEach((r) => {
    dep.push(r)
    dep.push(...getDependencies(r))
  })
  return _.uniqBy(dep, 'value')
}

/**
 * Génère un message de refus d'accès
 * @param right
 * @return {string}
 */
export const getForbiddenMessage = (right) => `Vous ne bénéficiez pas de l'autorisation "${right.label}".`
